module.exports = __webpack_public_path__ + "4638576278152958469948ce6de2de75.svg";